var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterFavorites({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 92 C46 92 43 89 40 86 L11 58 C2 49 2 34 11 24 C20 14 35 14 46 23 C48 25 49 26 50 27 C51 26 52 25 54 23 C65 14 80 14 89 24 C98 34 98 49 89 58 L60 86 C57 89 54 92 50 92 Z",
    stroke: "#FFFFFF",
    strokeWidth: 6.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFavorites);
export default __webpack_public_path__ + "static/media/footer_favorites.3e2b136d32b7d97784e649dda2feebf4.svg";
export { ForwardRef as ReactComponent };